import React, { useEffect, useState } from "react";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import {currentUserActions} from '../reducers/currentUser'
import LoginResetPasswordConfirm from '../components/LoginResetPasswordConfirm'
import LoginResetPasswordCompleted from '../components/LoginResetPasswordCompleted'
import { useSearchParams } from 'react-router-dom';
import NotFoundPage from "./NotFoundPage";

const ResetPasswordConfirm = ({view} : {view: 'company' | 'talent'}) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const currentUser = useSelector((state: any) => state.currentUser)
  const {isResetPwCompleted, passCheckCode} = currentUser
  useEffect(() => {
    dispatch(currentUserActions.setInitState())
    dispatch(currentUserActions.checkResetPasswordConfirm({resetPasswordCode: searchParams.get("reset_password_code"), view: view}))
  }, []);
  
  if(passCheckCode && passCheckCode !== "passed" && !isResetPwCompleted){
    if(passCheckCode === "failed") return <NotFoundPage />;
    return null;
  }

  return (
    <>
      {!isResetPwCompleted && (
        <LoginResetPasswordConfirm view={view} />
      )}
      {isResetPwCompleted && (
        <LoginResetPasswordCompleted view={view} />
      )}
    </>
  )
};

export default ResetPasswordConfirm;
